import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap-5';
import axios from 'axios';

import { tagProps } from './tag_table';

export default function ConfirmMergeTagsModal({
  databaseId,
  mergeTag,
  modalDisplay,
  selectedTags,
  onCloseModal,
  onMergeTags
}) {
  const handleSave = () => {
    const mergeTagIds = selectedTags.map(tag => (tag.id));

    return axios.post(`/database_settings/${databaseId}/tags/merge`, {
      id: mergeTag.id,
      merge_ids: mergeTagIds,
      database_id: databaseId
    }).then((response) => {
      onMergeTags(response.data);
      onCloseModal();
    }).catch((errors) => {
      console.warn(errors);
    });
  };

  const renderTagForm = () => {
    return (
      <div className="form-group">
        <p>
          Are you sure you want to merge <strong>{selectedTags.length} tags</strong> under the
          tag <strong>"{mergeTag ? mergeTag.name : ''}"</strong>?
        </p>
        <p>This action is permanent and cannot be undone.</p>
      </div>
    );
  };

  const renderTagFooter = () => {
    return (
      <div>
        <button className="btn btn-ghost" name="cancel" onClick={onCloseModal}>
          Cancel
        </button>
        <button className="btn btn-primary" name="save" onClick={handleSave}>
          Yes, Merge Tags
        </button>
      </div>
    );
  };

  return (
    <Modal
      name="tag-form-modal"
      show={modalDisplay}
      onHide={onCloseModal}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          Confirm Merge
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          {renderTagForm()}
        </div>
        <div className="mt-2">
          {renderTagFooter()}
        </div>
      </Modal.Body>
    </Modal>
  );
}

ConfirmMergeTagsModal.propTypes = {
  databaseId: PropTypes.number.isRequired,
  mergeTag: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string
  }),
  modalDisplay: PropTypes.bool.isRequired,
  selectedTags: PropTypes.arrayOf(tagProps),
  onCloseModal: PropTypes.func.isRequired,
  onMergeTags: PropTypes.func.isRequired,
};
